const ACTIVITY_MARKER_COLORS = {
  connect: '#bcdfff',
  connectActive: '#006fe4',
  unmask: '#ffcfd6',
  unmaskActive: '#ff435f',
  wordCity: '#c7f398',
  hangryGoblins: '#c7f398',
  cutItOut: '#c7f398',
  inlineActivity: '#dac1ff',
  evidenceTagging: '#ffc1ee',
};

export default ACTIVITY_MARKER_COLORS;
